module.exports = __webpack_public_path__ + "img/gegenbauer-light-logo.d531b986.svg";